import React from 'react';

function MenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#AC885B"
        strokeLinecap="round"
        strokeWidth="2"
        d="M5 7h14M5 12h14M5 17h14"
      ></path>
    </svg>
  );
}

export default MenuIcon;
